/*
 * Quick buy por tamanho no product card.
 *
 * Nao adiciona ao carrinho por conta propria: seleciona a variante no
 * [name="id"] e envia o form, deixando o <product-form> do theme-global.js
 * fazer o resto (carrinho, drawer, notificacoes e estados de erro).
 *
 * Delegacao no document para cobrir cards que chegam depois — paginacao
 * infinita, filtros, quickview e re-render de section no editor de temas.
 */
(function () {
  // o snippet e renderizado uma vez por card, entao o script pode vir repetido;
  // o listener e um so
  if (window.__bsQuickBuySizesReady) return;
  window.__bsQuickBuySizesReady = true;

  var SELETOR_TAMANHO = '.m-product-card__size[data-variant-id]';

  document.addEventListener('click', function (evento) {
    var alvo = evento.target.closest(SELETOR_TAMANHO);
    if (!alvo) return;

    var wrapper = alvo.closest('product-form');
    var form = wrapper && wrapper.querySelector('form');
    var inputId = form && form.querySelector('[name="id"]');
    if (!form || !inputId) return;

    evento.preventDefault();

    // o card inteiro costuma ser um link; sem isto o clique navega para a PDP
    evento.stopPropagation();

    inputId.value = alvo.dataset.variantId;
    inputId.disabled = false;

    // o tamanho nao fica marcado: aqui o clique adiciona ao carrinho, nao
    // escolhe nada que continue valendo no card. Quem marca e o card 7, dentro
    // de "Compre o conjunto", onde a selecao existe de verdade.
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  });
})();
